import React from 'react'
import carouselDefaultIcon from '../../assets/images/slider/sliderScrollIcon.svg'

const CarouselButton = ({
  useTriangle,
  color,
  disabled,
  clickHandler,
  clickerDisabled,
  customBtn,
  isLeftIcon,
}) => {
  return (
    <>
      {customBtn ? (
        <div
          disabled={disabled}
          onClick={clickHandler}
          style={{
            position: 'absolute',
            left: isLeftIcon ? '0' : '',
            right: isLeftIcon ? '' : '0',
            transform: isLeftIcon ? '' : 'rotate(180deg)',
          }}
        >
          {customBtn}
        </div>
      ) : (
        <button
          disabled={clickerDisabled}
          onClick={clickHandler}
          style={{ padding: 0, border: 'none', margin: 0 }}
        >
          <img
            src={carouselDefaultIcon}
            alt='prev'
            style={{
              position: 'absolute',
              left: isLeftIcon ? '15px' : '',
              right: isLeftIcon ? '' : '15px',
              transform: isLeftIcon ? '' : 'rotate(180deg)',
              borderRadius: '50%',
              height: '34px',
              width: '34px',
              background: 'rgba(0,0,0,0.35)',
              backdropFilter: 'blur(10px)',
              display: 'flex',
              alignItems: 'center',
              cursor: disabled ? 'text' : 'pointer',
              '-webkit-tap-highlight-color': 'rgba(0, 0, 0, 0)',
              '&:hover': {
                background: 'rgba(0,0,0,0.3)',
              },
              zIndex: 100,
              opacity: disabled ? '.24' : 1,
            }}
          />
        </button>
      )}
    </>
  )
}

export default CarouselButton
